// Generated by purs version 0.15.12
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var catchError = /* #__PURE__ */ Control_Monad_Error_Class.catchError(Effect_Aff.monadErrorAff);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Effect_Aff.monadThrowAff);
var empty = /* #__PURE__ */ Control_Plus.empty(Effect_Aff.plusAff);
var altPar = function (a1) {
    return function (a2) {
        return Effect_Aff.supervise(bind(liftEffect(Effect_Ref["new"](Data_Maybe.Nothing.value)))(function (f1Ref) {
            return bind(liftEffect(Effect_Ref["new"](Data_Maybe.Nothing.value)))(function (f2Ref) {
                return bind(Effect_Aff.suspendAff(bind(Effect_Aff.attempt(a1))(function (r1) {
                    return discard((function () {
                        if (r1 instanceof Data_Either.Right) {
                            return bind(liftEffect(Effect_Ref.read(f2Ref)))(function (mf2) {
                                return for_(mf2)(function (f2) {
                                    return Effect_Aff.killFiber(Effect_Exception.error("CancellationException1"))(f2);
                                });
                            });
                        };
                        if (r1 instanceof Data_Either.Left) {
                            return pure(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Fusion.ParAff (line 42, column 5 - line 48, column 26): " + [ r1.constructor.name ]);
                    })())(function () {
                        return pure(r1);
                    });
                })))(function (f1) {
                    return bind(Effect_Aff.suspendAff(bind(Effect_Aff.attempt(a2))(function (r2) {
                        return discard((function () {
                            if (r2 instanceof Data_Either.Right) {
                                return bind(liftEffect(Effect_Ref.read(f1Ref)))(function (mf1) {
                                    return for_(mf1)(function (f11) {
                                        return Effect_Aff.killFiber(Effect_Exception.error("CancellationException2"))(f11);
                                    });
                                });
                            };
                            if (r2 instanceof Data_Either.Left) {
                                return pure(Data_Unit.unit);
                            };
                            throw new Error("Failed pattern match at Fusion.ParAff (line 55, column 5 - line 61, column 26): " + [ r2.constructor.name ]);
                        })())(function () {
                            return pure(r2);
                        });
                    })))(function (f2) {
                        return discard(liftEffect(Effect_Ref.write(new Data_Maybe.Just(f1))(f1Ref)))(function () {
                            return discard(liftEffect(Effect_Ref.write(new Data_Maybe.Just(f2))(f2Ref)))(function () {
                                return bind(Effect_Aff.forkAff(Effect_Aff.joinFiber(f1)))(function (fr1) {
                                    return bind(Effect_Aff.forkAff(Effect_Aff.joinFiber(f2)))(function (fr2) {
                                        return bind(catchError(Effect_Aff.joinFiber(fr1))(function (err) {
                                            return pure(new Data_Either.Left(err));
                                        }))(function (r1) {
                                            return bind(catchError(Effect_Aff.joinFiber(fr2))(function (err) {
                                                return pure(new Data_Either.Left(err));
                                            }))(function (r2) {
                                                var v = new Data_Tuple.Tuple(r1, r2);
                                                if (v.value0 instanceof Data_Either.Right) {
                                                    return pure(v.value0.value0);
                                                };
                                                if (v.value0 instanceof Data_Either.Left && v.value1 instanceof Data_Either.Right) {
                                                    return pure(v.value1.value0);
                                                };
                                                if (v.value0 instanceof Data_Either.Left && (v.value1 instanceof Data_Either.Left && Effect_Exception.message(v.value0.value0) === "CancellationException2")) {
                                                    return throwError(v.value1.value0);
                                                };
                                                if (v.value0 instanceof Data_Either.Left && v.value1 instanceof Data_Either.Left) {
                                                    return throwError(v.value0.value0);
                                                };
                                                throw new Error("Failed pattern match at Fusion.ParAff (line 79, column 3 - line 83, column 48): " + [ v.constructor.name ]);
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        }));
    };
};
var parOneOf = function (dictFoldable) {
    var foldr = Data_Foldable.foldr(dictFoldable);
    return function (dictFunctor) {
        return function (actions) {
            return foldr(altPar)(empty)(actions);
        };
    };
};
export {
    altPar,
    parOneOf
};
